import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ResponseI } from '../../../../core/models/response';
import { environment } from '../../../../../environments/environment';

const apiUrl = environment.API_URI;

@Injectable({
  providedIn: 'root'
})
export class HotelService {
  rows: any;
  onInvoiceListChanged: BehaviorSubject<any>;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*'
    })
  }

  constructor(private http: HttpClient) {
    this.onInvoiceListChanged = new BehaviorSubject({});
   }

   /**
   * Resolver
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
      return new Promise<void>((resolve, reject) => {
        Promise.all([this.getData()]).then(() => {
          resolve();
        }, reject);
      });
    }

    private getHeaders(): HttpHeaders {
      const token = localStorage.getItem("user_token");
      return new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });
    }

  getData(): Promise<any[]> {
    if (localStorage.getItem('type') === 'admin') {
      return new Promise((resolve, reject) => {
        this.http.get(`${apiUrl}/hotel`, this.httpOptions).subscribe((response: any) => {
          console.log(response)
          this.rows = response.data;
          console.log(this.rows);
          
          this.onInvoiceListChanged.next(this.rows);
          resolve(this.rows);
        }, reject);
      });
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(`${apiUrl}/hotel`, this.httpOptions).subscribe((response: any) => {
          
          this.rows = response.data;
          console.log(this.rows);
          
          this.onInvoiceListChanged.next(this.rows);
          resolve(this.rows);
        }, reject);
      }); 
    }
  }

  getUsersEstablishments(){
    return this.http.get(`${apiUrl}/api/users/establishments`, {headers: this.getHeaders()});
  }

  getEstablishmentByUserId(id){
    return this.http.get(`${apiUrl}/api/establishments/users/${id}`, {headers: this.getHeaders()});
  }

  getHotelById(id): Observable<ResponseI> {
    return this.http.get<ResponseI>(`${apiUrl}/hotel/${id}`, this.httpOptions);
  }

  createEstablishment(establishment) {
    return this.http.post(`${apiUrl}/api/establishments`, establishment, {headers: this.getHeaders()});
  }

  createUser(user) {
    return this.http.post(`${apiUrl}/api/users`, user, {headers: this.getHeaders()});
  }

  findHotelByAdminId(id): Observable<ResponseI> {
    return this.http.get<ResponseI>(`${apiUrl}/hotel/provider/${id}`);
  }

  /* updateHotel(hotel): Observable<ResponseI> {
    return this.http.patch<ResponseI>(`${apiUrl}/hotel`, hotel, this.httpOptions);
  } */

  updateEstablishment(id, establishmentToUpdate) {
    return this.http.put(`${apiUrl}/api/establishments/${id}`, establishmentToUpdate, {headers: this.getHeaders()});
  }

  changeLogo(id, logo) {
    return this.http.put(`${apiUrl}/hotel/change-image/${id}`, logo);
  }

  deleteHotel(id): Observable<ResponseI> {
    return this.http.delete<ResponseI>(`${apiUrl}/hotel/${id}`, this.httpOptions);
  }
}
